import React from 'react'
import { createRoot } from 'react-dom/client'
import './bootstrap'
import './app.css'

import App from './app'

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')
const root = createRoot(container)

root.render(<App />)
